module.exports = __webpack_public_path__ + "static/media/logo_ncep.1da54adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ncep.png
// module id = 240
// module chunks = 0